import { createRouter, createWebHistory } from "vue-router";
import Accueil from "@/views/Accueil.vue";
import NotreMission from "@/views/NotreMission.vue";
import FaireUnDon from "@/views/FaireUnDon.vue";
import Adoption from "@/views/Adoption.vue";
import AnimauxPerdus from "@/views/AnimauxPerdus.vue";
import Erreur404 from "@/views/Erreur404.vue";
import FamilleAccueil from "@/views/FamilleAccueil.vue";
import Chatons_0_5Mois from "@/views/Chatons_0_5Mois.vue";
import Chatons_6_12Mois from "@/views/Chatons_6_12Mois.vue";
import ChatsFemelles from "@/views/ChatsFemelles.vue";
import ChatsMales from "@/views/ChatsMales.vue";
import ChatsCraintifs from "@/views/ChatsCraintifs.vue";
import ChatsAdoptes from "@/views/ChatsAdoptes.vue";
import Statistiques from "@/views/Statistiques.vue";
import LeveeDeFonds from "../views/LeveeDeFonds.vue";
import NosPartenaires from "@/views/NosPartenaires.vue";
import NousJoindre from "@/views/NousJoindre.vue";
import Admin from "@/views/Admin.vue";
import ListeChatsAdmin from "@/composants/ListeChatsAdmin.vue";
import AjouterChat from "@/composants/AjouterChat.vue";
import AfficherListeChats from "@/views/AfficherListeChats.vue";
import AfficherChatsFemelles from "@/views/AfficherChatsFemelles.vue";
import AfficherChatsMales from "@/views/AfficherChatsMales.vue";
import AfficherChatsCraintifs from "@/views/AfficherChatsCraintifs.vue";
import AfficherChatsAdoptes from "@/views/AfficherChatsAdoptes.vue";
import AfficherChatons0_5Mois from "../views/AfficherChatons0_5Mois.vue";
import AfficherChatons6_12Mois from "../views/AfficherChatons6_12Mois.vue";
import ConfirmationMessage from "@/views/ConfirmationMessage.vue";
import PolitiqueDeConfidentialite from "@/views/PolitiqueDeConfidentialite.vue";
import CookieCard from "@/components/CookieCard.vue";

const routes = [
  {
    path: "/",
    name: "accueil",
    component: Accueil,
    meta: { title: "Accueil - Animaux de la seconde chance " },
    title: "Animaux de la seconde chance",
  },
  {
    path: "/notre-mission",
    name: "NotreMission",
    component: NotreMission,
    meta: { title: "Notre Mission - Animaux de la seconde chance" },
    title: "Notre Mission - Animaux de la seconde chance",
  },
  {
    path: "/faire-un-don",
    name: "FaireUnDon",
    component: FaireUnDon,
    meta: { title: "Faire un don - Animaux de la seconde chance" },
    title: "Faire un don - Animaux de la seconde chance",
  },
  {
    path: "/adoption",
    name: "Adoption",
    component: Adoption,
    meta: { title: "Adoption - Animaux de la seconde chance" },
    title: "Adoption - Animaux de la seconde chance",
  },
  {
    path: "/famille-accueil",
    name: "FamilleAccueil",
    component: FamilleAccueil,
    meta: { title: "Famille d'accueil - Animaux de la seconde chance" },
    title: "Famille d'accueil - Animaux de la seconde chance",
  },
  {
    path: "/animaux-perdus",
    name: "AnimauxPerdus",
    component: AnimauxPerdus,
    meta: { title: "Animaux perdus - Animaux de la seconde chance" },
    title: "Animaux perdus - Animaux de la seconde chance",
  },
  {
    path: "/chatons-0-5-mois",
    name: "Chatons_0_5Mois",
    component: Chatons_0_5Mois,
    meta: { title: "Chatons de 6 à 12 mois - Animaux de la seconde chance" },
    title: "Chatons de 0 à 5 mois - Animaux de la seconde chance",
  },
  {
    path: "/chatons-6-12-mois",
    name: "Chatons_6_12Mois",
    component: Chatons_6_12Mois,
    meta: { title: "Chatons de 6 à 12 mois - Animaux de la seconde chance" },
    title: "Chatons de 6 à 12 mois - Animaux de la seconde chance",
  },
  {
    path: "/chats-femelles",
    name: "ChatsFemelles",
    component: ChatsFemelles,
    meta: { title: "Chats femelles - Animaux de la seconde chance" },
    title: "Chats femelles - Animaux de la seconde chance",
  },
  {
    path: "/chats-males",
    name: "ChatsMales",
    component: ChatsMales,
    meta: { title: "Chats mâles - Animaux de la seconde chance" },
    title: "Chats mâles - Animaux de la seconde chance",
  },
  {
    path: "/chats-craintifs",
    name: "ChatsCraintifs",
    component: ChatsCraintifs,
    meta: { title: "Chats craintifs - Animaux de la seconde chance" },
    title: "Chats craintifs - Animaux de la seconde chance",
  },
  {
    path: "/statistiques",
    name: "Statistiques",
    component: Statistiques,
    meta: { title: "Statistiques - Animaux de la seconde chance" },
    title: "Statistiques - Animaux de la seconde chance",
  },
  {
    path: "/nos-adoptes",
    name: "ChatsAdoptes",
    component: ChatsAdoptes,
    meta: { title: "Nos adoptés en 2025 - Animaux de la seconde chance" },
    title: "Nos adoptés en 2025 - Animaux de la seconde chance",
  },
  {
    path: "/levee-de-fonds",
    name: "LeveeDeFonds",
    component: LeveeDeFonds,
    meta: { title: "Levée de fonds - Animaux de la seconde chance" },
    title: "Levée de fonds - Animaux de la seconde chance",
  },
  {
    path: "/nos-partenaires",
    name: "NosPartenaires",
    component: NosPartenaires,
    meta: { title: "Nos partenaires - Animaux de la seconde chance" },
    title: "Nos partenaires - Animaux de la seconde chance",
  },
  {
    path: "/nous-joindre",
    name: "NousJoindre",
    component: NousJoindre,
    meta: { title: "Nous joindre - Animaux de la seconde chance" },
    title: "Nous joindre - Animaux de la seconde chance",
  },
  {
    path: "/admin",
    name: "Admin",
    component: Admin,
    meta: { title: "Administration - Animaux de la seconde chance" },
    title: "Administration - Animaux de la seconde chance",
  },
  {
    path: '/liste-chats-admin',
    name: 'ListeChatsAdmin',
    component: ListeChatsAdmin,
    meta: { title: "Liste des chats - Animaux de la seconde chance" },
    title: "Liste des chats - Animaux de la seconde chance",
  },
  {
    path: '/ajouter-chat',
    name: 'AjoutChat',
    component: AjouterChat,
    meta: { title: "Ajouter un chat - Animaux de la seconde chance" },
    title: "Ajouter un chat - Animaux de la seconde chance",
  },
  {
    path: '/liste-des-chats',
    name: 'AfficherListeChats',
    component: AfficherListeChats,
    meta: { title: "Liste des chats - Animaux de la seconde chance" },
    title: "Liste des chats - Animaux de la seconde chance",
  },
  {
    path: '/liste-chats-femelles',
    name: 'AfficherChatsFemelles',
    component: AfficherChatsFemelles,
    meta: { title: "Liste des chats femelles - Animaux de la seconde chance" },
  },
  {
    path: '/liste-chats-males',
    name: 'AfficherChatsMales',
    component: AfficherChatsMales,
    meta: { title: "Liste des chats males - Animaux de la seconde chance" },
    title: "Liste des chats males - Animaux de la seconde chance",
  },
  {
    path: '/liste-chats-craintifs',
    name: 'AfficherChatsCraintifs',
    component: AfficherChatsCraintifs,
    meta: { title: "Liste des chats craintifs - Animaux de la seconde chance" },
    title: "Liste des chats craintifs - Animaux de la seconde chance",
  },
  {
    path: '/liste-chats-adoptes',
    name: 'AfficherChatsAdoptes',
    component: AfficherChatsAdoptes,
    meta: { title: "Liste des chats adoptes - Animaux de la seconde chance" },
    title: "Liste des chats adoptes - Animaux de la seconde chance",
  },
  {
    path: '/afficher-chatons-0-5-mois',
    name: 'AfficherChatons0_5Mois',
    component: AfficherChatons0_5Mois,
    title: "Liste des chatons de 0 à 5 mois - Animaux de la seconde chance",
    meta: { title: "Liste des chatons de 0 à 5 mois - Animaux de la seconde chance" },
  },
  {
    path: '/afficher-chatons-6-12-mois',
    name: 'AfficherChatons6_12Mois',
    component: AfficherChatons6_12Mois,
    title: "Liste des chatons de 6 à 12 mois - Animaux de la seconde chance",
    meta: { title: "Liste des chatons de 6 à 12 mois - Animaux de la seconde chance" },
  },
  {
    path: '/confirmation-message',
    name: 'ConfirmationMessage',
    component: ConfirmationMessage,
    title: "Confirmation - Animaux de la seconde chance",
    meta: { title: "Confirmation - Animaux de la seconde chance" },
  },
  {
    path: '/protection-des-renseignements-personnels',
    name: 'PolitiqueDeConfidentialite',
    component: PolitiqueDeConfidentialite,
    title: "Politique de confidentialité - Animaux de la seconde chance",
    meta: { title: "Politique de confidentialité - Animaux de la seconde chance" },
  },
  {
    path: "/cookies",
    name: "CookieCard",
    component: CookieCard,
  },
  {
    path: "/:pathMatch(.*)*",
    name: "NotFound",
    component: Erreur404,
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
  linkActiveClass: "text-[#2fa960] border-[#2fa960] bg-cyan-50", // Classe pour les liens actifs
  linkExactActiveClass: "bg-primaire text-white", // Classe pour les liens exactement actifs
  scrollBehavior(to, from, savedPosition) {
    if (to.hash) {
      return {
        el: to.hash,
        behavior: 'smooth',
      };
    } else if (savedPosition) {
      return savedPosition;
    } else {
      return { top: 0 };
    }
  },
});


export default router;
